<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
        </div>


        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>媒体专访</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="publish_main">
            <p class="book_name">《量子大唠嗑》新书发布</p>

            <p class="book_p">
                内容介绍
            </p>

            <p class="con_p">
                师从超冷原子物理理论之父Keith Burnett，25岁牛津大学博士毕业；美国国家标准局读博士后，师从量子调控实验之父William Phillips
                （1997年诺贝尔奖获得者）；伯克利研究助理，芝加哥大学访问教授，30岁入选中国科学院百人计划，研究员、正教授博导，作为首席科学家，
                为中国空间站天宫四号设计了世界第一个空间冷原子量子实验平台。名门正派打下扎实的物理学的底子；科学家的身份，为功成名就铺了道路。
                可是，就是在学术生涯势头正劲的时候，就在量子科学成为流行名词的时候，《量子大唠嗑》的作者--35岁的马兆远做了圈子的出走者。
            </p>

            <p class="con_p">
                凭着科学的初心，以物理学以实验为核心的体验主义精神，他卷起袖子做了实业，希望去做一场科学研究与产业创新联系的实验。
                《量子大唠嗑》可以算做实验过程中的一些心得笔记。
            </p>
            
            <p class="title_mid">
                科学是认识世界的方法之一，但它是那个比较靠谱的。
            </p>

            <p class="con_p">
                《量子大唠嗑》的第一部分说明了一件事，科学不是绝对真理和也不代表绝对权威。科学仅仅是认识这个世界的
                相对靠谱的方法，但它因为理性的不完备而充满了开放的活力。马兆远长期从事量子力学研究，在《量子大唠嗑》的第二部分，
                他把所感的关于量子的情况细致道来，让你清楚地认识到量子，认识到量子物理能应用到的场合以及量子究竟给这个世界带来怎样的改变。
            </p>

            <p class="title_mid">
                二十一世纪了，你还在用十八世纪的思维看这个世界吗？
            </p>

             <p class="con_p">
                用牛顿经典物理学处理人与自然的关系的思维方法对后来三百年的社会产生了深远的影响。
                这种思维方法被其他研究领域的人认可并借鉴。利用这套思维，亚当·斯密分析总结出了经济规律、达尔文分析总结出了生物演化规律、
                马克思分析总结出了社会发展规律、佛洛依德分析总结出了人的心理发展规律、德鲁克分析总结出了企业管理规律……
            </p>

            <p class="con_p">
                可是这个世界的状况越来越复杂，客观实在、因果关系、科学的理性等等，以前建立起来的经典观在时代发展的过程中似乎不那么万无一失，
                在将量子物理学成果应用于科技实业创业的过程中，马兆远发现除了将量子物理应用于物理科研本身之外，量子物理学还带来了强有力的思维借鉴。
                这种思维的借鉴是否会在新的时代里产生新的亚当·斯密、达尔文、马克思、佛洛伊德、德鲁克……来应对现今及未来社会遇到的、
                用以前的牛顿经典物理学思维已经无法解释的新状况？《量子大唠嗑》第三部分探索性地从复杂关联角度，将量子科学引入到人类社会生活领域，
                引入到社会、经济、组织管理、工业升级换代、人工智能等等情境中，也许能启迪读者找到新的工具。
            </p>

            <p class="title_mid" style="text-indent: 2em">
                天再旦者，卯时日全食之谓也。我们需要这样一场"天再旦"。
            </p>

            <div class="book_down">
                <p class="book_title">作者简介</p>
                <p class="bookboss">马兆远何许人也？</p>

　              <p class="bookboss">17岁保送北大；</p>

　              <p class="bookboss">25岁牛津大学物理学博士毕业；</p>

　              <p class="bookboss">美国国家标准局、加州大学伯克利分校博士后；</p>

　              <p class="bookboss">师从超冷原子物理理论之父Keith Burnett爵士和量子调控实验之父William Phillips(1997年诺贝尔奖获得者)；</p>

　              <p class="bookboss">30岁入选中国科学院百人计划，成为研究员、正教授博导；</p>

　              <p class="bookboss">为中国空间站-天宫四号设计了世界第一个空间冷原子量子实验平台；</p>

　              <p class="bookboss">就在科学职业势头正劲时，35岁的马兆远做了圈子的出走者，挽起袖子做实业，马兆远把实业作为一场科学    
                                    技术与产业创新联系的实验。</p>

                <div class="bookimg">
                    <p class="thep" style="font-size: 24px;font-weight: normal;text-align: left;">目录</p>
                    <div class="book_left">
                        前言  <br>
                        <div class="list_left"><p class="line-list">第一部分</p><i></i><span>1</span></div>
                        <div class="list_left">
                            <p>一 三个问题</p>
                            <i style="width: 243px;"></i>
                            <span>3</span>
                        </div>
                        <div class="list_left">
                            <p>二　信仰从哪里来？ </p>
                            <i style="width: 185px;"></i>
                            <span>11</span>
                        </div>
                        <div class="list_left">
                            <p>三　经典科学的诞生  </p>
                            <i style="width: 185px;"></i>
                            <span>21</span>
                        </div>
                        <div class="list_left">
                            <p>四　体验的新科学</p>
                            <i style="width: 195px;"></i>
                            <span>31</span>
                        </div>
                        <div class="list_left">
                            <p>五　一百年前的旧文字</p>
                            <i style="width: 165px;"></i>
                            <span>39</span>
                        </div>
                        <div class="list_left">
                            <p>六　科学共同体</p>
                            <i style="width: 210px;"></i>
                            <span> 45</span>
                        </div>
                        <div class="list_left">
                            <p>七　科学与技术</p>
                            <i style="width: 210px;"></i>
                            <span> 61</span>
                        </div>
                        <div class="list_left">
                            <p>八　科学和信仰 </p>
                            <i style="width: 210px;"></i>
                            <span> 69</span>
                        </div>
                        <div class="list_left">
                            <p>九　捣蛋鬼哥德尔</p>
                            <i style="width: 190px;"></i>
                            <span>83</span>
                        </div>
                        <div class="list_left">
                            <p>十　神秘论</p>
                            <i style="width: 230px;"></i>
                            <span>101</span>
                        </div>
                        <div class="list_left">
                            <p>十一　不必科学的中医 </p>
                            <i style="width: 160px;"></i>
                            <span>123</span>
                        </div>
                        <div class="list_left">
                            <p>第二部分  </p>
                            <i style="width: 245px;"></i>
                            <span>129</span>
                        </div>
                        <div class="list_left">
                            <p>一　量子力学的逻辑建立</p>
                            <i style="width: 145px;"></i>
                            <span>131</span>
                        </div>
                        <div class="list_left">
                            <p>二　双缝干涉实验 </p>
                            <i style="width: 185px;"></i>
                            <span>143</span>
                        </div>
                        <div class="list_left">
                            <p>三　因果论 </p>
                            <i style="width: 230px;"></i>
                            <span>157</span>
                        </div>
                        <div class="list_left">
                            <p>四　猫</p>
                            <i style="width: 255px;"></i>
                            <span>165</span>
                        </div>
                        <div class="list_left">
                            <p>五　量子纠缠的缘起</p>
                            <i style="width: 170px;"></i>
                            <span>175</span>
                        </div>
                        <div class="list_left">
                            <p>六　稍稍深入的量子力学</p>
                            <i style="width: 145px;"></i>
                            <span>187</span>
                        </div>
                        <div class="list_left">
                            <p>七　量子模拟实验</p>
                            <i style="width: 185px;"></i>
                            <span>203</span>
                        </div>
                        <div class="list_left">
                            <p>八　经典之外的量子力学</p>
                            <i style="width: 144px;"></i>
                            <span>223</span>
                        </div>
                        <div class="list_left">
                            <p>九　量子力学、哥德尔和杜威的体验主义</p>
                            <i style="width: 45px;"></i>
                            <span>243</span>
                        </div>
                        <div class="list_left">
                            <p>第三部分　复杂体系</p>
                            <i style="width: 170px;"></i>
                            <span>255</span>
                        </div>
                        <div class="list_left">
                            <p>一　量子模拟和人工智能</p>
                            <i style="width: 145px;"></i>
                            <span>257</span>
                        </div>
                        <div class="list_left">
                            <p>二　科学和技术的创新</p>
                            <i style="width: 155px;"></i>
                            <span>269</span>
                        </div>
                        <div class="list_left">
                            <p>三　教育的体验</p>
                            <i style="width: 200px;"></i>
                            <span>279</span>
                        </div>
                        <div class="list_left">
                            <p>四　管理创新团队</p>
                            <i style="width: 190px;"></i>
                            <span>287</span>
                        </div>
                        <div class="list_left">
                            <p>五　大脑的冥想体验</p>
                            <i style="width: 170px;"></i>
                            <span>299</span>
                        </div>
                        <div class="list_left">
                            <p>六　营造创新组织</p>
                            <i style="width: 185px;"></i>
                            <span>305</span>
                        </div>
                        <div class="list_left">
                            <p>七　去工业化的进程</p>
                            <i style="width: 170px;"></i>
                            <span>317</span>
                        </div>
                        <div class="list_left">
                            <p>八　为设计而教育</p>
                            <i style="width: 185px;"></i>
                            <span>329</span>
                        </div>
                        <div class="list_left">
                            <p>后记</p>
                            <i style="width: 266px;"></i>
                            <span>347</span>
                        </div>



                    </div>
                    <img src="../../../assets/images/139.png" alt="">
                </div>
                 
            </div>
             

        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
     /* height: 681px; */
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }
 .banner_warp {
     position: absolute;
     top: 0px;
     left: 19%;
 }
 .top-text {
     width: 570px;
     position: absolute;
     top: 300px;

 }
 .top-text p:nth-child(1) {
     font-size: 40px;
     color: #ffffff;
 }
 .top-text p:nth-child(2) {
     font-size: 19px;
     color: #ffffff;
     margin-top: 10px;
 }

/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}


.publish_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    padding-bottom: 60px;
}
.publish_main .book_name {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
    margin-bottom: 90px;
}
.publish_main .book_p {
    font-size: 24px;
    margin-bottom: 28px;
}
.publish_main .con_p {
    font-size: 14px;
    text-indent: 2em;
    margin: 0px;
}
.publish_main .title_mid {
    font-size: 14px;
    font-weight: 700;
    margin-top: 28px;
    margin-bottom: 28px;
}
.publish_main img{
    display: block;
    margin: 0 auto;
    margin-bottom: 100px;
    margin-top: 60px;
}

/* 下方的内容和图片 */
.book_down {
    margin-top: 80px;
}
.publish_main .book_down .book_title {
    font-size: 24px;
    margin-bottom: 33px;
    font-weight: normal;
    text-align: left;
}

.book_down .bookboss {
    font-size: 14px;
    margin-bottom: 28px;
    text-align: center;
}

/* 下方图片 */
.bookimg {
    overflow: hidden;
    margin-top: 90px;
}
.book_down .bookimg .thep {
    font-size: 26px;
    margin-bottom: 33px;
}

/* 左侧目录 */
.book_left {
    font-size: 14px;
    width: 333px;
    float: left;
}
.bookimg img {
    float: right;
    margin-top: 216px;
    margin-left: 300px;
}
.publish_main .bookimg .book_left .list_left p {
    font-size: 14px;
    margin: 0px;
    float: left;
}
.bookimg .book_left .list_left i {
    width: 260px;
    display: block;
    border-top: 1px dashed #333;
    float: left;
    margin: 13px 3px 0px 3px;
}
.bookimg .book_left .list_left {
    width: 100%;
    height: 26px;
}
.bookimg .book_left span {
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/news/book/book.vue